/*
 * Maison Olynne — Cross-sell du panier
 * ------------------------------------------------------------
 * Ce fichier est charge une fois, depuis layout/theme.liquid, et non
 * depuis le snippet qui rend le bloc.
 *
 * La raison est concrete : le snippet ne rend la suggestion que si elle
 * a du sens. Un panier vide n'en affiche aucune, donc un <script> pose
 * a l'interieur de cette condition ne s'executerait jamais au premier
 * chargement. Et quand cart-drawer.js remplace ensuite le contenu du
 * tiroir via innerHTML, les balises <script> injectees de cette maniere
 * ne sont jamais executees par le navigateur — le bloc apparaitrait
 * avec un bouton inerte.
 *
 * Defini ici, le composant est enregistre des le chargement de la page.
 * Les <mo-cart-crosssell> inseres plus tard par innerHTML sont alors
 * promus automatiquement par le navigateur.
 */
if (!customElements.get('mo-cart-crosssell')) {
  customElements.define(
    'mo-cart-crosssell',
    class MoCartCrosssell extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.button = this.querySelector('[data-xsell-add]');
        this.errorEl = this.querySelector('.mo-xsell__error');
        this.loading = false;
        if (this.button) this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick() {
        if (this.loading) return;
        const id = parseInt(this.dataset.variantId, 10);
        if (!id) return;

        this.setLoading(true);
        this.hideError();

        const cart =
          document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items: [{ id: id, quantity: 1 }] };

        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(() => {
            this.showError('');
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(state) {
        this.loading = state;
        if (!this.button) return;
        this.button.classList.toggle('loading', state);
        this.button.setAttribute('aria-busy', state ? 'true' : 'false');
        this.button.disabled = state;
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || this.getAttribute('data-error') || '';
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
      }
    }
  );
}
